import { Link, useLocation } from 'react-router-dom';
import { LoginButton } from '@/components/auth/LoginButton';
import styles from './Header.module.css';

const navItems = [
  { path: '/', label: 'Home' },
  { path: '/race', label: 'Race' },
  { path: '/progress', label: 'Progress' },
];

export function Header() {
  const location = useLocation();

  return (
    <header className={styles.header}>
      <div className={styles.brand}>
        <Link to="/" className={styles.logo}>
          <img src="/icons/toko_math.png" alt="TOKO Math Club" className={styles.logoImage} />
          <span className={styles.logoText}>TOKO Math Club</span>
        </Link>
      </div>

      <nav className={styles.nav}>
        {navItems.map((item) => (
          <Link
            key={item.path}
            to={item.path}
            className={`${styles.navLink} ${
              location.pathname === item.path ? styles.active : ''
            }`}
          >
            {item.label}
          </Link>
        ))}
      </nav>

      <div className={styles.actions}>
        <LoginButton />
      </div>
    </header>
  );
}
